import React from "react";

import Entities from "../../components/Entities";

function Manufacturers() {
  return (
    <Entities
      shema={{
        searchFromServer: true,
        searchRoute: "manufacturers",
        fields: [
          { name: "Name", propertyName: "name", search: true },
          {
            name: "Status",
            propertyName: "status",
          },
        ],
      }}
    />
  );
}

export default Manufacturers;
